/* WP · Barra superior: mensaje deslizante + progreso de envío gratis (Ecom Project) */
(function () {
  'use strict';

  function money(cents, FMT) {
    cents = Math.max(0, Math.round(cents));
    function fmt(n, dec, th, ds) {
      var p = (n / 100).toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(ds);
    }
    return (FMT || 'S/. {{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return fmt(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(cents, 0, '.', ',');
      return fmt(cents, 2, ',', '.');
    });
  }

  function init(root) {
    if (!root || root.__wptb) return;
    var prog = root.querySelector('.wptb__progress');
    var mq = root.querySelector('.wptb__marquee');
    var msgEl = root.querySelector('[data-wptb-msg]');
    if (!prog || !mq || !msgEl) return;
    root.__wptb = true;

    var TH = parseInt(root.getAttribute('data-threshold'), 10) || 0;
    var FMT = root.getAttribute('data-format');
    var CART = root.getAttribute('data-cart-url') || '/cart';
    var OFFSET = parseInt(root.getAttribute('data-offset'), 10) || 80;
    var fills = root.querySelectorAll('[data-wptb-fill]');
    var M = {};
    try { M = JSON.parse(root.querySelector('[data-wptb-msgs]').textContent); } catch (e) {}

    var last = null;
    function render(total, count) {
      total = +total || 0; count = +count || 0;
      var rem = TH - total, pct, html;
      if (count === 0 || total <= 0) { html = M.empty; pct = 0; }
      else if (rem > 0) { html = (M.remaining || '').replace(/\[faltante\]/g, money(rem, FMT)); pct = Math.min(96, Math.max(4, total / TH * 100)); }
      else { html = M.done; pct = 100; }
      html = (html || '').replace(/\[monto\]/g, M.monto || money(TH, FMT));
      var key = html + '|' + pct;
      if (key === last) return;
      var changed = last !== null;
      last = key;
      msgEl.innerHTML = html;
      for (var i = 0; i < fills.length; i++) fills[i].style.width = pct + '%';
      root.classList.toggle('is-free', rem <= 0 && count > 0);
      if (changed && root.classList.contains('is-progress')) {
        root.classList.remove('is-bump'); void root.offsetWidth; root.classList.add('is-bump');
      }
    }

    var on = null;
    function check() {
      if (!root.isConnected) { window.removeEventListener('scroll', check); return; }
      var s = (window.pageYOffset || document.documentElement.scrollTop || 0) > OFFSET;
      if (s === on) return;
      on = s;
      root.classList.toggle('is-progress', s);
      prog.setAttribute('aria-hidden', s ? 'false' : 'true');
      prog.tabIndex = s ? 0 : -1;
      mq.setAttribute('aria-hidden', s ? 'true' : 'false');
    }
    window.addEventListener('scroll', check, { passive: true });
    check();

    function openCart() {
      var btn = document.querySelector('.cart-badge-container, [data-cart-drawer-toggle]');
      if (btn) btn.click(); else window.location.href = CART;
    }
    prog.addEventListener('click', openCart);
    prog.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openCart(); }
    });

    var timer;
    function refresh() {
      if (!root.isConnected) { document.removeEventListener('wptb:cart', refresh); return; }
      clearTimeout(timer);
      timer = setTimeout(function () {
        fetch(CART + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            render(c.total_price, c.item_count);
            // el contador del carrito también se actualiza cuando el cambio lo hizo una app o un script externo
            if (window.updateCartBadges) { try { window.updateCartBadges(); } catch (e) {} }
          })
          .catch(function () {});
      }, 180);
    }
    document.addEventListener('wptb:cart', refresh);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

    render(root.getAttribute('data-total'), root.getAttribute('data-count'));
  }

  /* Detecta cambios del carrito hechos por el tema o por apps (fetch y XHR). */
  if (!window.__wptbCartHook) {
    window.__wptbCartHook = true;
    var RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$|\/)/;
    var ping = function () { document.dispatchEvent(new CustomEvent('wptb:cart')); };
    if (window.fetch) {
      var of = window.fetch;
      window.fetch = function (input) {
        var p = of.apply(window, arguments);
        try {
          var u = typeof input === 'string' ? input : (input && input.url) || '';
          if (RX.test(u)) p.then(ping, function () {});
        } catch (e) {}
        return p;
      };
    }
    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { if (RX.test(String(u))) this.addEventListener('loadend', ping); } catch (e) {}
      return oo.apply(this, arguments);
    };
  }

  /* Newsletter del footer: el texto de ejemplo viene en inglés desde el tema; se muestra en español y con etiqueta accesible. */
  function fixNewsletter() {
    var els = document.querySelectorAll('footer input[type="email"], .footer input[type="email"], input[name="contact[email]"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (/enter your/i.test(el.getAttribute('placeholder') || '')) el.setAttribute('placeholder', 'Tu correo electrónico');
      if (!el.getAttribute('aria-label') && !(el.id && document.querySelector('label[for="' + el.id + '"]'))) el.setAttribute('aria-label', 'Tu correo electrónico');
    }
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-wptb][data-progress]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixNewsletter); else fixNewsletter();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); fixNewsletter(); });
})();
